import React, { FC } from 'react';
import DOMPurify from 'dompurify';

export interface Props {
  value: string;
}

const HtmlField: FC<Props> = ({ value }: Props) => {
  if (value.length > 0) {
    return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(value) }}></div>;
  } else {
    return <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize('-') }}></div>;
  }
};

export default HtmlField;
